// extracted by mini-css-extract-plugin
export default {"title":"e9da2fcea1","inner_title":"cd94eef0a1","charge_btn":"c7d6e7a828"};